/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _regeneratorRuntime = _interopDefault(require('babel-runtime/regenerator'));
var _asyncToGenerator = _interopDefault(require('babel-runtime/helpers/asyncToGenerator'));
var __ol__ = _interopDefault(require('openlayers'));
var interaction = _interopDefault(require('../mixin/interaction'));
var vueHelpers = require('../util/vue-helpers');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

/**
 * @vueProps
 */
var SnapInteraction = __ol__.interaction.Snap;
var props = {
  /**
   * Target source identifier from IdentityMap.
   * @type {string}
   */
  source: {
    type: String,
    required: true
  },
  /**
   * Snap to edges
   * @type {boolean}
   */
  edge: {
    type: Boolean,
    default: true
  },
  /**
   * Snap to vertices.
   * @type {boolean}
   */
  vertex: {
    type: Boolean,
    default: true
  },
  /**
   * Pixel tolerance for considering the pointer close enough to a segment or vertex for snapping.
   * @type {number}
   */
  pixelTolerance: {
    type: Number,
    default: 10
  }

  /**
   * @vueMethods
   */
};var methods = {
  /**
   * @return {Promise<ol.interaction.Draw>}
   * @protected
   */
  createInteraction: function createInteraction() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var sourceIdent, source;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sourceIdent = _this.makeIdent(_this.source);
              _context.next = 3;
              return _this.$identityMap.get(sourceIdent, _this.$options.INSTANCE_PROMISE_POOL);

            case 3:
              source = _context.sent;
              return _context.abrupt('return', new SnapInteraction({
                source: source
              }));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    interaction.methods.mount.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    interaction.methods.unmount.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  subscribeAll: function subscribeAll() {}
};

var watch = vueHelpers.makeWatchers(['source'], function () {
  return function () {
    this.scheduleRecreate();
  };
});

/**
 * @alias module:snap-interaction/interaction
 * @title vl-interaction-snap
 * @vueProto
 */
var Interaction = {
  name: 'vl-interaction-snap',
  mixins: [interaction],
  props: props,
  methods: methods,
  watch: watch
};

/**
 * @alias module:snap-interaction
 */
var index = {
  /**
   * @alias module:snap-interaction/interaction
   */
  Interaction: Interaction,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Interaction, options);

    Vue.component(Interaction.name, Interaction);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/snap-interaction/index.js
// module id = 1485
// module chunks = 1